import React from 'react';
import { useI18n } from '../../../../data/hooks/i18nHooks';
import ActionButton from '../../../elements/ActionButton/ActionButton';

function ReadMoreButton(props) {
    const { article } = props,
        { read_more_url } = article,
        i18n = useI18n();

    if (!read_more_url) return null;

    return (
        <ActionButton next secondary href={article.read_more_url}>
            {i18n['label.read-more']}
        </ActionButton>
    );
}

export default ReadMoreButton;
